import React, { PureComponent } from 'react'

import { ResponsiveEmbed, IFrame } from 'components'

import './video.scss'

class Video extends PureComponent {
	onRemove = () => {
		const { editor, node } = this.props

		editor.removeNodeByKey(node.key)
	}

	render() {
		const { attributes, url } = this.props

		return (
			<div {...attributes} className={`c-video${attributes.className}`}>
				<ResponsiveEmbed ratio="16-9">
					<IFrame src={url} />
				</ResponsiveEmbed>
			</div>
		)
	}
}

export default Video
